import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { COLOURS, FillInBlanksAnswer } from '../fill-in-blanks.constants';

export function getFillInBlanksAnswerColour(
  answer: FillInBlanksAnswer
): ColourItem {
  return COLOURS.find(colours => colours.base === answer.colour) || COLOURS[0];
}
